module.exports = __webpack_public_path__ + "static/img/7.96a9a62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/7.png
// module id = 5+WD
// module chunks = 0